import Log from "./pages/Log";
import './App.css';
import { useEffect } from 'react';
import { enableAntiDebug, disableDevToolsShortcuts } from './helpers/antiDebug';

function App() {
    useEffect(() => {
        // 启用所有反调试功能
        enableAntiDebug();
        disableDevToolsShortcuts();
    }, []);

    return (
        <div className="App-body">
            <Log />
            <div className="App-footer">
                <p>© 2025 <a href="https://aigc.9b7.cn" target="_blank" rel="noopener noreferrer">AIGC工具站</a>. All Rights Reserved.</p>
                <p>本站API适用于测试和体验目的，请自觉遵守您当地法律法规，切勿用于非法用途，本站不承担任何法律责任。</p>
            </div>
        </div>
    );
}

export default App;
